import { ApiCall } from "../apiBase";

/********get cafepage query********/
export async function updateCafePage(cafepageId, updatedCafepage) {
  let cafePages = [];

  const result = await ApiCall({
    method: "post",
    data: {
      query: `
        mutation updateCafepage($id: ID!
          $input: CafepageInput!) {
            updateCafepage(id: $id, input: $input) {
                id
                closeMessage
                title
                description
                titleImages
                slider_images
            }
        }
      `,
      variables: {
        id: cafepageId,
        input: {
          closeMessage: updatedCafepage.closeMessage,
          title: updatedCafepage.title,
          description: updatedCafepage.description,
          titleImages: updatedCafepage.titleImages,
          slider_images: updatedCafepage.slider_images,
        },
      },
    },
  });

  if (!result.data.errors && result.data.data.updateCafepage) {
    cafePages = result.data.data.updateCafepage;
  }

  return cafePages;
}

/********update gallerypage query********/
export async function updateGalleryPage(gallerypageId, gallery_images) {
  let galleryPages = [];

  const result = await ApiCall({
    method: "post",
    data: {
      query: `
          mutation updateGallerypage($id: ID!
            $input: GallerypageInput!) {
              updateGallerypage(id: $id, input: $input) {
                  id
                  gallery_images
              }
          }
        `,
      variables: {
        id: gallerypageId,
        input: {
          gallery_images: gallery_images,
        },
      },
    },
  });

  if (!result.data.errors && result.data.data.updateGallerypage) {
    galleryPages = result.data.data.updateGallerypage;
  }

  return galleryPages;
}

/********update Generalpage query********/
export async function updateGeneralDetails(id, updatedGeneral) {
  let generalPages = [];

  const result = await ApiCall({
    method: "post",
    data: {
      query: `
          mutation updateGeneralpage($id: ID!, $input: GeneralpageInput!) {
              updateGeneralpage(id: $id, input: $input) {
                  id
                  coverImage
                  headerImage
                  email
                  phone
                  address
                  footer_description
                  doc_imprint
                  doc_dataProtection
                  doc_termsAndConditions
              }
          }
        `,
      variables: {
        id: id,
        input: {
          coverImage: updatedGeneral.coverImage,
          headerImage: updatedGeneral.headerImage,
          email: updatedGeneral.email,
          phone: updatedGeneral.phone,
          address: updatedGeneral.address,
          footer_description: updatedGeneral.footer_description,
          doc_imprint: updatedGeneral.doc_imprint,
          doc_dataProtection: updatedGeneral.doc_dataProtection,
          doc_termsAndConditions: updatedGeneral.doc_termsAndConditions,
        },
      },
    },
  });

  if (!result.data.errors && result.data.data.updateGeneralpage) {
    generalPages = result.data.data.updateGeneralpage;
  }

  return generalPages;
}

/********updateHomepage query********/
export async function updateHomePage(id, updatedHomepage) {
  let homePage = null;

  const result = await ApiCall({
    method: "post",
    data: {
      query: `
          mutation updateHomepage($id: ID!, $input: HomepageInput!) {
              updateHomepage(id: $id, input: $input) {
                id
                banner_image
                danube_videolink
                danube_title
                danube_description
                aboutus_title
                aboutus_description
                card1_title
                card1_description
                card2_title
                card2_description
                card3_img
                card4_img
                slider_galary
                slider_URL
              }
          }
        `,
      variables: {
        id: id,
        input: {
          banner_image: updatedHomepage.banner_image,
          danube_videolink: updatedHomepage.danube_videolink,
          danube_title: updatedHomepage.danube_title,
          danube_description: updatedHomepage.danube_description,
          aboutus_title: updatedHomepage.aboutus_title,
          aboutus_description: updatedHomepage.aboutus_description,
          card1_title: updatedHomepage.card1_title,
          card1_description: updatedHomepage.card1_description,
          card2_title: updatedHomepage.card2_title,
          card2_description: updatedHomepage.card2_description,
          card3_img: updatedHomepage.card3_img,
          card4_img: updatedHomepage.card4_img,
          slider_galary: updatedHomepage.slider_galary,
          slider_URL: updatedHomepage.slider_URL,
        },
      },
    },
  });

  if (!result.data.errors && result.data.data.updateHomepage) {
    homePage = result.data.data.updateHomepage;
  }

  return homePage;
}

/********updateTestimonial query********/
export async function updateTestimonial(testimonialId, updatedTestimonial) {
  let testimonial = null;

  const result = await ApiCall({
    method: "post",
    data: {
      query: `
        mutation updateTestimonial($id: ID!, $input: TestimonialInput!) {
          updateTestimonial(id: $id, input: $input) {
            id
            name
            photo
            designation
            description
          }
        }
      `,
      variables: {
        id: testimonialId,
        input: {
          name: updatedTestimonial.name,
          photo: updatedTestimonial.photoURL,
          designation: updatedTestimonial.designation,
          description: updatedTestimonial.feedback,
        },
      },
    },
  });

  if (!result.data.errors && result.data.data.updateTestimonial) {
    testimonial = result.data.data.updateTestimonial;
  }

  return testimonial;
}

/********get cafepage query********/
export async function getCafePage() {
  let cafePages = [];

  const result = await ApiCall({
    method: "post",
    data: {
      query: `
          query getCafepage {
              getCafepage {
                  id
                  closeMessage
                  title
                  description
                  titleImages
                  slider_images
              }
          }
        `,
    },
  });

  if (!result.data.errors && result.data.data.getCafepage) {
    cafePages = result.data.data.getCafepage;
  }

  return cafePages;
}

/********get gallerypage query********/
export async function getGalleryPage() {
  let galleryPages = [];

  const result = await ApiCall({
    method: "post",
    data: {
      query: `
            query getGallerypage {
                getGallerypage {
                    id
                    gallery_images
                }
            }
          `,
    },
  });

  if (!result.data.errors && result.data.data.getGallerypage) {
    galleryPages = result.data.data.getGallerypage;
  }

  return galleryPages;
}

/********get Generalpage query********/
export async function getGeneralDetails() {
  let generalPages = [];

  const result = await ApiCall({
    method: "post",
    data: {
      query: `
            query getGeneralpage {
                getGeneralpage {
                    id
                    coverImage
                    headerImage
                    email
                    phone
                    address
                    footer_description
                    doc_imprint
                    doc_dataProtection
                    doc_termsAndConditions
                }
            }
          `,
    },
  });

  if (!result.data.errors && result.data.data.getGeneralpage) {
    generalPages = result.data.data.getGeneralpage;
  }

  return generalPages;
}

/********getHomepage query********/
export async function getHomePage() {
  let homePages = [];

  const result = await ApiCall({
    method: "post",
    data: {
      query: `
            query getHomepage {
                getHomepage {
                  id
                  banner_image
                  danube_videolink
                  danube_title
                  danube_description
                  aboutus_title
                  aboutus_description
                  card1_title
                  card1_description
                  card2_title
                  card2_description
                  card3_img
                  card4_img
                  slider_galary
                  slider_URL
                }
            }
          `,
    },
  });

  if (!result.data.errors && result.data.data.getHomepage) {
    homePages = result.data.data.getHomepage;
  }

  return homePages;
}

/********getTestimonials query********/
export async function getTestimonials() {
  let testimonials = [];

  const result = await ApiCall({
    method: "post",
    data: {
      query: `
            query getTestimonials {
                getTestimonials {
                  id
                  name
                  photo
                  designation
                  description
                }
            }
          `,
    },
  });

  if (!result.data.errors && result.data.data.getTestimonials) {
    testimonials = result.data.data.getTestimonials;
  }

  return testimonials;
}

/********add Testimonial query********/
export async function addTestimonial(addTestimonial) {
  let testimonial = null;

  const result = await ApiCall({
    method: "post",
    data: {
      query: `
          mutation addTestimonial($input: TestimonialInput!) {
            addTestimonial(input: $input) {
                id
                name
                photo
                designation
                description
              }
          }
        `,
      variables: {
        input: {
          name: addTestimonial.name,
          photo: addTestimonial.photoURL,
          designation: addTestimonial.designation,
          description: addTestimonial.feedback,
        },
      },
    },
  });

  if (!result.data.errors && result.data.data.addTestimonial) {
    testimonial = result.data.data.addTestimonial;
  }

  return testimonial;
}

/********delete a Testimonial********/
export async function deleteTestimonial(id) {
  let deleteTestimonialRes = null;
  let success = false;

  const result = await ApiCall({
    method: "post",
    data: {
      query: `
          mutation deleteTestimonial($id: ID!) {
            deleteTestimonial(id: $id) {
              id
              name
              photo
              designation
              description
            }
          }
        `,
      variables: {
        id: id,
      },
    },
  });

  if (!result.data.errors && result.data.data.deleteTestimonial) {
    deleteTestimonialRes = result.data.data.deleteTestimonial;
  }

  if (deleteTestimonialRes) {
    success = true;
  }

  return success;
}

/*************** Get Testimonial Query ************/
export async function getTestimonial(feedbackId) {
  let testimonial = null;

  const result = await ApiCall({
    method: "post",
    data: {
      query: `
            query getTestimonial ($input: ID!){
                getTestimonial(id: $input) {
                  id
                  name
                  photo
                  designation
                  description
                }
            }
          `,
      variables: {
        input: feedbackId,
      },
    },
  });

  if (!result.data.errors && result.data.data.getTestimonial) {
    testimonial = result.data.data.getTestimonial;
  }

  return testimonial;
}
